module.exports = __webpack_public_path__ + "static/media/pdrc_logo.3d1eaaaf.png";